import { groupBy } from 'lodash';

import {
  type ConditionViolationsStatus,
  ConditionViolationType,
} from '@/warranty/domain/entities/condition-violation-status';
import type { ConditionsViolationTimeseriesData } from '@/warranty/domain/entities/condition-violation-timeseries';

export interface ConditionViolationRow {
  'platform_core_warranty_condition_unit_alerts.description_id': string;
  'platform_core_warranty_condition_unit_alerts.extreme_value_agg': number;
  'platform_core_warranty_condition_unit_alerts.value_unit': string;
  'platform_core_warranty_condition_unit_alerts.last_detection': string;
  'platform_core_warranty_condition_unit_alerts.duration_h_agg': number;
  'platform_core_warranty_condition_unit_alerts.count_agg': number;
}

export interface ConditionViolationTimeseriesRow {
  'platform_core_warranty_condition_unit_alerts.description_id': string;
  'platform_core_warranty_condition_unit_alerts.analysis_date': string;
  'platform_core_warranty_condition_unit_alerts.count_agg': number;
}

export function transformConditionViolationStatus(
  result: ConditionViolationRow,
): ConditionViolationsStatus {
  return {
    id: result['platform_core_warranty_condition_unit_alerts.description_id'],
    groupFullId: '',
    topFullId: '',
    unitFullId: '',
    fullFrontendId: '',
    description: result[
      'platform_core_warranty_condition_unit_alerts.description_id'
    ] as ConditionViolationType,
    extremeValue:
      result['platform_core_warranty_condition_unit_alerts.extreme_value_agg'],
    unit: result['platform_core_warranty_condition_unit_alerts.value_unit'],
    latestDetect: new Date(
      result['platform_core_warranty_condition_unit_alerts.last_detection'],
    ),
    duration:
      result['platform_core_warranty_condition_unit_alerts.duration_h_agg'],
    affectedUnits:
      result['platform_core_warranty_condition_unit_alerts.count_agg'],
  };
}

export function transformConditionViolationTimeseriesRow(
  result: ConditionViolationTimeseriesRow,
) {
  return {
    description: result[
      'platform_core_warranty_condition_unit_alerts.description_id'
    ] as ConditionViolationType,
    timestamp: new Date(
      result['platform_core_warranty_condition_unit_alerts.analysis_date'],
    ),
    count: result['platform_core_warranty_condition_unit_alerts.count_agg'],
  };
}

export function transformConditionViolationTimeseriesData(
  data: ReturnType<typeof transformConditionViolationTimeseriesRow>[],
): ConditionsViolationTimeseriesData[] {
  const groupedData = Object.entries(groupBy(data, 'description'));

  return groupedData.map<ConditionsViolationTimeseriesData>(
    ([description, timeseries]) => ({
      id: description,
      fullFrontendId: '',
      topFullId: '',
      groupFullId: '',
      unitFullId: '',
      description: description as ConditionViolationType,
      timeseries,
    }),
  );
}
